import { useMemo, type ReactNode } from 'react';

import { createBrowserQueryCache } from './query-cache';
import { BrowserQueryCacheContext } from './query-cache-context';

export function BrowserQueryCacheProvider({ children }: { children: ReactNode }): JSX.Element {
  const cache = useMemo(() => createBrowserQueryCache(), []);

  return <BrowserQueryCacheContext.Provider value={cache}>{children}</BrowserQueryCacheContext.Provider>;
}
